import { ActionReducer, INIT } from "@ngrx/store";
import { EngagementFlowWithProgramEngagementFlowDto } from "src/app/services/api";

import { RootState } from ".";
import { AppState } from "./app/state";

/** Must match the value in functions/lib/constants.ts */
export const JERI_STATE_ID = "__JERI_STATE__";

/** Shape must match BootstrapData in functions/lib/fetch-bootstrap.ts */
export interface ServerBootstrapData {
  program: AppState["program"];
  programIntegrations: AppState["programIntegrations"];
  features: AppState["features"];
  tiers: AppState["tiers"];
  engagementFlows?: EngagementFlowWithProgramEngagementFlowDto[] | null;
}

export function serverStateSync(reducer: ActionReducer<RootState>): ActionReducer<RootState> {
  return (state, action) => {
    const nextState = reducer(state, action);

    if (action.type === INIT) {
      const serverData = readAndRemoveServerState();
      if (serverData) {
        return {
          ...nextState,
          app: {
            ...nextState.app,
            program: serverData.program,
            programIntegrations: serverData.programIntegrations,
            features: serverData.features,
            tiers: serverData.tiers,
            ...(Array.isArray(serverData.engagementFlows)
              ? {
                  engagementFlows: toEngagementFlowsRecord(serverData.engagementFlows, nextState.app.engagementFlows),
                }
              : {}),
          },
        };
      }
    }

    return nextState;
  };
}

function readAndRemoveServerState(): ServerBootstrapData | null {
  try {
    const el = document.getElementById(JERI_STATE_ID);
    if (!el?.textContent) return null;

    const data = JSON.parse(el.textContent) as ServerBootstrapData;
    el.remove();

    if (!data?.program) return null;

    return data;
  } catch {
    return null;
  }
}

function toEngagementFlowsRecord(
  engagementFlows: EngagementFlowWithProgramEngagementFlowDto[],
  current: AppState["engagementFlows"],
): AppState["engagementFlows"] {
  const next = { ...current };
  engagementFlows.forEach(engagementFlow => {
    next[engagementFlow.name] = engagementFlow;
  });
  return next;
}
